

























































































import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'reservationObjectCardDetails',
  data() {
    return {
      timeUntilReservationEnds: null as string | null,
      timeInterval: 0,
    };
  },
  props: {
    reservationObject: {
      type: Object,
      required: true,
    },
    manualGroupObject: {
      type: Object,
      required: false,
    },
    locationObject: {
      type: Object,
      required: false,
    },
    entranceObject: {
      type: Object,
      required: false,
    },
    timeslotObject: {
      type: Object,
      required: false,
    },
    visitTypeObject: {
      type: Object,
      required: false,
    },
  },
  methods: {
    updateExpiringTime() {
      if (
        (!this.timeslotObject && (!this.manualGroupObject || !this.manualGroupObject.startTime || !this.manualGroupObject.endTime)) ||
        !this.isPresent
      ) {
        return;
      }

      const date = moment().format('YYYY-MM-DD');
      const endTime = this.manualGroupObject ? this.manualGroupObject.endTime : this.timeslotObject.endTime;

      const diff = moment(`${date}T${endTime}`).diff(moment());
      const duration = moment.duration(diff);

      this.timeUntilReservationEnds = Math.floor(duration.asHours()) + moment.utc(diff).format(':mm:ss');
    },
  },
  computed: {
    isPresent(): boolean {
      const date = this.manualGroupObject ? moment().format('YYYY-MM-DD') : this.reservationObject.startDate;

      const startTime = this.manualGroupObject ? this.manualGroupObject.startTime : this.timeslotObject.startTime;
      const endTime = this.manualGroupObject ? this.manualGroupObject.endTime : this.timeslotObject.endTime;

      return moment().isBetween(moment(`${date}T${startTime}`), moment(`${date}T${endTime}`), undefined, '[]');
    },
    isFuture(): boolean {
      return !this.manualGroupObject
        ? moment().isBefore(moment(`${moment(this.reservationObject.startDate).format('YYYY-MM-DD')}T${this.timeslotObject.startTime}`))
        : false;
    },
    allDay(): boolean {
      const startTime = this.manualGroupObject ? this.manualGroupObject.startTime : this.timeslotObject.startTime;
      const endTime = this.manualGroupObject ? this.manualGroupObject.endTime : this.timeslotObject.endTime;

      return ['00:00:00', '00:00:01'].includes(startTime) && ['23:59:59', '00:00:00'].includes(endTime);
    },
  },
  created() {
    this.updateExpiringTime();

    (this.timeInterval as any) = setInterval(() => {
      this.updateExpiringTime();
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.timeInterval);
  },
});
